import axios from 'axios';

// API URL - use environment variable or default to localhost
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';

/**
 * Navigation Service
 * Handles all navigation-related API calls and redirects
 */
const NavigationService = {
  /**
   * Navigate to a course page and log the visit
   * @param {string} courseId - The ID of the course
   * @param {string} pageLink - The link to navigate to
   * @param {function} navigate - React Router's navigate function
   */
  navigateToCourse: async (courseId, pageLink, navigate) => {
    try {
      // Log the course visit to the backend (for analytics)
      await axios.post(`${API_URL}/api/analytics/course-visit`, { courseId });
      
      // Navigate to the course page
      navigate(pageLink);
    } catch (error) {
      console.error('Error logging course visit:', error);
      // Still navigate even if logging fails
      navigate(pageLink);
    }
  },

  /**
   * Navigate to a training page and log the visit
   * @param {string} trainingType - The type of training (long-term or short-term)
   * @param {string} pageLink - The link to navigate to
   * @param {function} navigate - React Router's navigate function
   */
  navigateToTraining: async (trainingType, pageLink, navigate) => {
    try {
      // Log the training visit to the backend (for analytics)
      await axios.post(`${API_URL}/api/analytics/training-visit`, { trainingType });
      
      // Navigate to the training page
      navigate(pageLink);
    } catch (error) {
      console.error('Error logging training visit:', error);
      // Still navigate even if logging fails
      navigate(pageLink);
    }
  },

  /**
   * Navigate to contact page and log the visit
   * @param {string} pageLink - The link to navigate to
   * @param {function} navigate - React Router's navigate function
   */
  navigateToContact: async (pageLink, navigate) => {
    try {
      // Log the contact page visit to the backend (for analytics)
      await axios.post(`${API_URL}/api/analytics/contact-visit`);
      
      // Navigate to the contact page
      navigate(pageLink);
    } catch (error) {
      console.error('Error logging contact visit:', error);
      // Still navigate even if logging fails
      navigate(pageLink);
    }
  },

  /**
   * Handle enrollment button click
   * @param {string} courseId - The ID of the course
   * @param {function} navigate - React Router's navigate function
   */
  handleEnrollNow: async (courseId, navigate) => {
    try {
      // Log the enrollment intent to the backend
      await axios.post(`${API_URL}/api/analytics/enrollment-intent`, { courseId });
      
      // Navigate to the enrollment form
      navigate('/enroll', { state: { courseId } });
    } catch (error) {
      console.error('Error logging enrollment intent:', error);
      // Still navigate even if logging fails
      navigate('/enroll', { state: { courseId } });
    }
  },

  /**
   * Handle get directions button click
   * @param {string} locationName - The name of the location
   */
  openGoogleMaps: (locationName) => {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationName)}`;
    window.open(googleMapsUrl, '_blank');
  }
};

export default NavigationService;
